import type { GeometryType, VectorSchema } from "@frontend/pages/case-workspace/radiology/types"

const ALL_GEOMETRY_TYPES: GeometryType[] = ["polygon", "polyline", "rectangle", "ellipse", "point", "freehand"]

interface VectorModulePanelProps {
  schema: VectorSchema
  activeLabelKey: string | null
  onActiveLabelKey: (key: string | null) => void
  activeGeometryType: GeometryType
  onActiveGeometryType: (type: GeometryType) => void
}

export function VectorModulePanel({
  schema,
  activeLabelKey,
  onActiveLabelKey,
  activeGeometryType,
  onActiveGeometryType
}: VectorModulePanelProps) {
  const availableTypes = schema.geometry_types ?? ALL_GEOMETRY_TYPES
  const labels = schema.labels ?? []

  return (
    <div className="flex-1 overflow-auto p-3 space-y-4">
      <div>
        <div className="text-[10px] font-medium text-muted-foreground uppercase tracking-wide mb-2">Geometry</div>
        <div className="flex flex-wrap gap-1">
          {availableTypes.map((gt) => (
            <button
              key={gt}
              onClick={() => onActiveGeometryType(gt)}
              className={`px-2 py-1 rounded-md border text-[10px] capitalize transition-colors ${
                activeGeometryType === gt
                  ? "border-primary/60 bg-primary/10"
                  : "border-border bg-surface-raised hover:bg-accent/40"
              }`}
            >
              {gt}
            </button>
          ))}
        </div>
      </div>

      {labels.length > 0 && (
        <div>
          <div className="text-[10px] font-medium text-muted-foreground uppercase tracking-wide mb-2">Labels</div>
          <div className="space-y-1">
            {labels.map((lbl) => (
              <button
                key={lbl.key}
                onClick={() => onActiveLabelKey(activeLabelKey === lbl.key ? null : lbl.key)}
                className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-md border text-left transition-colors ${
                  activeLabelKey === lbl.key
                    ? "border-primary/60 bg-primary/10"
                    : "border-border bg-surface-raised hover:bg-accent/40"
                }`}
              >
                <span
                  className="size-3 rounded-sm shrink-0 border border-white/20"
                  style={{ backgroundColor: lbl.color }}
                />
                <span className="text-[11px] font-medium truncate">{lbl.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
